<template>
  <div class="news">
    <div class="" v-if="arrs.length">
      <router-link :to="url + item.id" v-for="(item, index) in arrs" :key="index">
        <div class="doculist">
          <div class="listdate">
            <div class="date">{{ item.publishTime.substr(8, 2) }}</div>
            <div class="year">{{ item.publishTime.substr(0, 7) }}</div>
          </div>
          <div class="docutit">
            <div class="title">
              {{ item.title }}
              <span :class="cmpState(item) === '进行中' ? 'state' : 'stateover'" v-if="item.docType == 1">{{ cmpState(item) }}</span>
            </div>
            <div class="brief" v-html="item.content"></div>
            <div class="author">
              <span class="authoricon">发布者：{{ item.author }}</span>
              <span class="dataicon" v-if="item.beginTime">起止日期：{{ item.beginTime }} 到 {{ item.endTime }}</span>
              <span class="dataicon" v-else>发布时间：{{ item.publishTime }}</span>
            </div>
          </div>
          <div class="pull-right">
            <div class="rightinfo">
              <a-button type="primary" shape="round" class="btn">查看详情</a-button>
            </div>
          </div>
        </div>
      </router-link>
    </div>
    <div v-else style="text-align: center; width: 100%; padding: 20px">
      <span>暂无数据</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'documentList',
  props: {
    arrs: Array,
    url: String,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    cmpState({ beginTime, endTime }) {
      // 将字符串日期转换为Date对象
      const startTime = new Date(beginTime);
      const endingTime = new Date(endTime);
      const currentTime = new Date();

      // 比较时间
      if (currentTime >= startTime && currentTime <= endingTime) {
        return '进行中';
      } else if (currentTime < startTime) {
        return '未开始';
      } else {
        return '已结束';
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';
.docType {
  background-color:#ccc;
  border:1px solid #ccc;
  font-size:5px;
  border-radius: 70px;
  padding:2px 5px;
  margin-left:10px;
}
.news {
  background: #fff;
  padding:28px;
  min-height: calc(100vh - 676px);
  min-width: 800px;
}

.doculist{
  background:#f7f9f8;
  padding:20px;
  padding-left: 0px;
  padding-right: 30px;
  margin-bottom:30px;
  height:126px;
  display: flex;

&:hover{
   box-shadow: 0px 0px 10px #999;
 }
.listdate{
  border-right:#cad7d2 1px dashed;
  width: 120px;
  color: #2caf7a;
  height:96px;
  font-family: ReductoSSK,tahoma, 'microsoft yahei', 'PingFang SC', 'PingFang', 'Helvetica Neue', 'Microsoft YaHei', Helvetica,
  Arial, sans-serif, '\5FAE\8F6F\96C5\9ED1';
  text-align: center;
  font-size: 16px;
  margin-right:20px;
.date{
  padding-top:5px;
  margin-bottom:10px;
  font-size: 45px;
}
}
.docutit{
  flex: 1;
  margin-right: 30px;
  padding-right: 0px;
}
.title{
  font-size:16px;
  font-weight: bold;
  line-height:24px;
  color: #666;
  margin-bottom:10px;
span{
  color: #FFFFFF;
  font-size: 13px;
  height: 23px;
  width: 57px;
  display: inline-block;
  padding-left: 12px;
  margin-left:8px;
  font-weight: normal!important;
  line-height: 23px;
}
.state{
  background: url("../../../assets/images/statebg.png") center top no-repeat;
}
.stateover{
  background: url("../../../assets/images/statebg.png") left top no-repeat;
  background-position:0px -23px;
}
}
.brief{
  font-size:14px;
  color:#666666;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp:1; /* 显示3行文本 */
  overflow: hidden;
  margin-bottom: 10px;

  img {
    display: none;
  }
}
.rightinfo{
  margin-top: 29px;
}
.author{
  color: #999;
  font-size: 14px;
  margin-top:20px;
span{
  margin-right: 20px;
  padding-left: 24px;
}
.authoricon{
  background: url("../../../assets/images/authoricon.png") left no-repeat;
}
.dataicon{
  background: url("../../../assets/images/dataicon.png") left no-repeat;
}
}
}

.btn{
  background-color:$bgColor ;
  border: $bgColor solid 1px;
}
</style>



// WEBPACK FOOTER //
// src/pages/documentcenter/component/documentList.vue